<template class="blue">
  <v-card flat tile dark class="mb-4 blue">
    <v-toolbar flat dark class="blue">
      <v-toolbar-title class="mx-auto">{{title}} </v-toolbar-title>
    </v-toolbar>
    <v-container fluid grid-list-lg class="mt-0 pt-0">
      <v-layout row wrap class="mb-2">
        <v-flex xs12>
          <div class="text-xs-center" id="valButtons">
            <div class="headline"></div>
            <v-flex xs12 text-xs-center mx-auto>
              <div v-for="item in activityTypes" v-bind:key="item.actId">
                <v-btn block xs6 round light :to="'/val/'+item.actId">{{item.text}}</v-btn>
              </div>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-center" id="valButtons">
            <div class=" toolbar__title mb-2">Quick-Add From History</div>
            <v-flex xs12 text-xs-center mx-auto>
              <div v-for="itemq in quickAddButtons" v-bind:key="itemq.itemAct+itemq.itemIntesity+itemq.itemVal">
                <v-btn block xs6 round light style="height: 50px;" :to="'/val/'+itemq.actTypeID+'/'+itemq.actIntensVal+'/'+itemq.actTotalVal+''">
                  {{itemq.itemAct}} <br>
                  {{itemq.itemIntesity}}:
                  {{itemq.itemVal}}pts
                </v-btn>
              </div>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>



</template>

<script>
  import AppConst from '../AppConst.js'
  import GetActivityByUserQuery from '../queries/GetActivityByUserQuery';
  import ListActivitiesByUserQuery from '../queries/ListActivitiesByUserQuery';


  var actObj = AppConst.activityTypesDefaults;
  var actIntensityObj = AppConst.activityIntensityTypesDefaults;


  function getButtons(that, callback) {

    that.$apollo.query({
      variables: {
        username: localStorage.subID,
      },
      query: ListActivitiesByUserQuery
    })
      .then(function logData(data) {
        if (data.data.listActivitiesByUser.items !== null) {
          var counter = 0;
          var buttonstring = [];
          data.data.listActivitiesByUser.items.forEach(function (item) {
            if (counter < 4) {

              if (item.activityType !== "VoiceFeeling" && item.activityType != "Sick" && item.activityType != "WaterConsumption" && item.activityType != "NapTaken" && item.activityType != "VoiceCeilingPitch") {
                var actTypeVal = actObj.filter(act => act.text == item.activityType)[0].actId;
                var actIntensVal = actIntensityObj.filter(act => (actTypeVal == act.actId) && (act.name == item.intensity))[0];
                var actDurVal = item.value / actIntensVal.value * 60;
                buttonstring.push({
                  'actTypeID': actTypeVal,
                  'actIntensVal': actIntensVal.value,
                  'actTotalVal': actDurVal,
                  'itemAct': item.activityType,
                  'itemIntesity': item.intensity,
                  'itemVal': item.value
                });
                counter++;
              }
            }
          });
        }

        callback(buttonstring);

      }).catch(console.error);

  }


  export default {
    data() {
      return {
        title: 'Select Activity Type',
        activityTypes: actObj,
        GetActivityByUserQuery: GetActivityByUserQuery,
        quickAddButtons: '',
      }
    },
    mounted() {
      var that = this;
      getButtons(this, function (data) {
        that.quickAddButtons = data;
      });
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/val/ValType.vue